import * as $ from 'jquery';

const settings = {
	input: '.js-car-registration',
	button: '.js-add-car',
	max: 10,
}

var counter = 0;

export const init = () => {
	counter = $(settings.input).length;

	if (counter >= settings.max) {
		$(settings.button).hide();
	}

	$(settings.button).on('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();

		const $last = $(settings.input).last();
		const $new = $last.clone();

		// Clear the value
		$new.find('input').val('').attr('name', 'data[Car][' + (counter++) + '][registration]');

		// Attach the copy
		$last.parent().append($new);

		if (counter >= settings.max) {
			$(settings.button).hide();
		}
	});
}

init();
